import { Injectable } from '@angular/core';
import {
  ContractorAvailabilityDto,
  ContractorAvailabilityException,
  CreateContractorAvailabilityException,
  IContractorAvailabilityDataService,
  Shift,
  ShiftsService
} from '@umss/shared/data-access';
import { Observable } from 'rxjs';
import { ContractorService } from './contractor.service';

@Injectable({ providedIn: 'root' })
export class FacilityContractorAvailabilityDataService implements IContractorAvailabilityDataService {
  constructor(
    private contractorService: ContractorService,
    private shiftsService: ShiftsService
  ) {}

  getAvailability(
    contractorId?: string
  ): Observable<ContractorAvailabilityDto[]> {
    return this.contractorService.getContractorAvailability(contractorId!);
  }

  getAvailabilityExceptions(
    contractorId?: string,
    params?: { startDate: string; endDate: string }
  ): Observable<ContractorAvailabilityException[]> {
    return this.contractorService.getContractorAvailabilityExceptions(
      contractorId!,
      params
    );
  }

  getShiftsForMonth(
    year: number,
    month: number,
    contractorId?: string
  ): Observable<Shift[]> {
    return this.shiftsService.getContractorShiftsForMonth(
      contractorId!,
      year,
      month
    );
  }

  createAvailabilityException(
    exception: CreateContractorAvailabilityException,
    contractorId?: string
  ): Observable<ContractorAvailabilityException> {
    return this.contractorService.createContractorAvailabilityException(
      contractorId!,
      exception
    );
  }

  deleteAvailabilityException(
    exceptionId: number,
    contractorId?: string
  ): Observable<void> {
    return this.contractorService.deleteContractorAvailabilityException(
      contractorId!,
      exceptionId
    );
  }
}
